<!-- Post Property Alert Modal -->
<div class="modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Post Property Alert</h5>
                <button type="button" class="close" aria-label="Close" (click)="skip()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- New green div strip -->
                <div style="background-color: #d4edda; color: #155724; font-weight: bold; font-size: 1.2em; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                    Profile details successfully updated
                </div>

                <p>
                    Do you want to Post Property Now? Click on the "Post Now" button below. <br /> 
                    In case you want to Post later, Click on + button in the menu to add a property
                </p>

                <!-- Centered image and text -->
                <div style="text-align: center; margin-top: 20px;">
                    <!-- Replacing SVG with an image -->
                    <img src="assets/icons/postimg.png" alt="Post Property" height="40px;" width="200px">
                </div>
            </div>
            <div class="modal-footer justify-content-end">
                <button class="btn btn-primary me-2" (click)="postNow()">Post Now</button>
                <button class="btn btn-secondary" (click)="skip()">Skip</button>
            </div>
        </div>
    </div>
</div>
